import { CODE_ENV_LIST, ORIGIN_FILE_PATH } from '@/common/constants/ConstCode';

export default {
  setProduct(state, data = { contentKr: '', contentVn: '', contentEn: '' }) {
    let { contentKr, contentVn, contentEn } = data;

    let replacePath = `${ORIGIN_FILE_PATH}|
    https://user.youthmarketvn.com|
    https://store.youthmarketvn.com|
    https://super.youthmarketvn.com`;

    data.contentKr = contentKr?.replace(new RegExp(replacePath, 'g'), CODE_ENV_LIST.S3_FILE_SERVER_URL);

    data.contentVn = contentVn
      ? contentVn?.replace(new RegExp(replacePath, 'g'), CODE_ENV_LIST.S3_FILE_SERVER_URL)
      : contentKr?.replace(new RegExp(replacePath, 'g'), CODE_ENV_LIST.S3_FILE_SERVER_URL);
    data.contentEn = contentEn
      ? contentEn?.replace(new RegExp(replacePath, 'g'), CODE_ENV_LIST.S3_FILE_SERVER_URL)
      : contentKr?.replace(new RegExp(replacePath, 'g'), CODE_ENV_LIST.S3_FILE_SERVER_URL);

    state.product = data;
  },

  setList: (state, list = []) => (state.products = [...state.products, ...list]),

  setPage: (state, page = 1) => (state.page = page),
  setTotalPage: (state, totalPage = 2) => (state.totalPage = totalPage),
  setPageInfo: (state, pageInfo) => (state.pageInfo = pageInfo),

  initList: (state) => {
    state.page = 1;
    state.totalPage = 2;
    state.products = [];
  }
};
